import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api, ApiError, dateAr, STATUS_AR } from '../lib/api';
import { TopBar, Notice } from '../components/ui';
import { OtpStep } from '../components/Otp';
import { Mark } from '../components/Logo';

type Membership = { member_id: string; name: string; member_no: string; card_token: string; shop_name: string; slug: string; district: string | null; renewal_mode: 'auto' | 'link'; sub_id: string | null; status: string | null; visits_left: number | null; visits_total: number | null; cycle_end: string | null; plan_name: string | null };

/** Member hub: one phone, all memberships across every barber. */
export default function Me() {
  const [phone, setPhone] = useState('');
  const [step, setStep] = useState<'phone' | 'otp' | 'list'>('phone');
  const [items, setItems] = useState<Membership[]>([]);
  const [error, setError] = useState('');
  async function load(token: string) {
    try {
      const r = await api.post<{ memberships: Membership[] }>('/api/public/me/memberships', { phone, verification_token: token });
      setItems(r.memberships); setStep('list');
    } catch (e) { setError(e instanceof ApiError ? (e.message_ar ?? e.message) : 'تعذر جلب عضوياتك.'); }
  }
  return (
    <main className="min-h-dvh pb-16">
      <TopBar />
      <div className="container max-w-xl grid gap-4">
        <div><div className="eyebrow">عضوياتي</div><h1 className="mt-1">كل عضوياتك في مكان واحد</h1><p className="muted mt-2">رقم جوالك يفتح بطاقاتك عند كل الحلاقين المشتركين في تيمبو.</p></div>
        {step === 'phone' && (
          <section className="card p-6 grid gap-4">
            <div><label className="label" htmlFor="phone">رقم جوالك (عليه واتساب)</label><input id="phone" className="field num" dir="ltr" inputMode="tel" placeholder="05xxxxxxxx" value={phone} onChange={(e) => setPhone(e.target.value)} autoComplete="tel" /></div>
            <button className="btn btn-primary btn-lg" disabled={phone.replace(/\D/g, '').length < 9} onClick={() => setStep('otp')}>متابعة</button>
          </section>
        )}
        {step === 'otp' && (
          <section className="card p-6 grid gap-4">
            <OtpStep phone={phone} onVerified={load} label="افتح عضوياتي" />
            {error && <Notice kind="danger">{error}</Notice>}
            <button className="btn btn-ghost" onClick={() => setStep('phone')}>غيّر الرقم</button>
          </section>
        )}
        {step === 'list' && (
          <section className="grid gap-3">
            {items.length === 0 && <div className="card p-6"><Notice kind="info">لا توجد عضويات على هذا الرقم بعد. امسح رمز محلك لتشترك.</Notice></div>}
            {items.map((m) => (
              <Link key={m.member_id} to={`/card/${m.card_token}`} className="card p-5 flex items-center gap-4 hover:border-ink">
                <div className="shrink-0"><Mark size={40} /></div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2"><h3 className="truncate">{m.shop_name}</h3>{m.status && <span className={`pill ${m.status === 'active' ? 'pill-ok' : m.status === 'canceled' || m.status === 'withdrawn' ? 'pill-danger' : 'pill-warn'}`}>{STATUS_AR[m.status] ?? m.status}</span>}</div>
                  <div className="muted text-sm">{m.district ?? ''}{m.plan_name ? ` · ${m.plan_name}` : ''} · عضوية {m.member_no}</div>
                  {m.sub_id && <div className="num text-sm mt-1">المتبقي من حلاقاتك: {m.visits_left}{m.cycle_end ? ` · حتى ${dateAr(m.cycle_end)}` : ''}</div>}
                </div>
              </Link>
            ))}
            <p className="muted text-xs">كل بطاقة مرتبطة بمحلها، ولا تُستخدم في محل آخر.</p>
          </section>
        )}
      </div>
    </main>
  );
}
